<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h10">Copyright</h1>
<p class="p1"><span class="t2"><img alt="img2.jpg" height="48" src="Images/img2.jpg" width="48"/></span></p>
<p class="p0"><span class="t2">Pubblicato da</span></p>
<p class="p1">D<span class="t3">REAMSPINNER</span> P<span class="t3">RESS</span></p>
<p class="p0"><span class="t2">5032 Capital Circle SW, Suite 2, PMB# 279, Tallahassee, FL 32305-7886  USA</span></p>
<p class="p1"><span class="t2">http://www.dreamspinnerpress.com/</span></p>
<p class="p2"><span class="t2">Questa è un’opera di fantasia. Nomi, personaggi, luoghi e avvenimenti sono il prodotto dell’immaginazione dell’autore o sono usati in modo fittizio e ogni somiglianza a persone reali, vive o morte, imprese commerciali, eventi o località è puramente casuale.</span></p>
<p class="p3"><span class="t2">Salvare Sean</span></p>
<p class="p3"><span class="t2">Copyright dell’edizione italiana © 2015 Dreamspinner Press.</span></p>
<p class="p3"><span class="t2">Saving Sean</span></p>
<p class="p3"><span class="t2">© 2012 Con Riley.</span></p>
<p class="p2"><span class="t2">Traduzione di Rebecca Cornia.</span></p>
<p class="p3"><span class="t2">Illustrazione di copertina di</span></p>
<p class="p3"><span class="t2">© 2012 Anne Cain.</span></p>
<p class="p3"><span class="t2">annecain.art@gmail.com</span></p>
<p class="p2"><span class="t2">Le immagini di copertina sono usate a soli scopi illustrativi e i soggetti ritratti in esse sono modelli.</span></p>
<p class="p2"><span class="t2">Tutti i diritti riservati. Nessuna parte di questo libro può essere riprodotta o trasmessa in alcuna forma o con alcun mezzo, elettronico o meccanico, incluse fotocopie, registrazioni, o da qualsiasi sistema di deposito e recupero di informazioni senza il permesso scritto dell’Editore, eccetto laddove permesso dalla legge. Per richiedere il permesso e per qualunque altra domanda, contattare Dreamspinner Press, 5032 Capital Cir. SW, Ste 2 PMB# 279, Tallahassee, FL 32305-7886, USA or http://www.dreamspinnerpress.com/.</span></p>
<p class="p3"><span class="t2">Edizione eBook italiano: 978-1-62380-744-3</span></p>
<p class="p3"><span class="t2">Prima edizione italiana: Luglio 2015</span></p>
<p class="p2"><span class="t2">Prima Edizione Aprile 2012</span></p>
<p class="p4"><span class="t2">Stampato negli Stati Uniti d’America.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?4862fb2d